module.exports = __webpack_public_path__ + "static/media/Users.9a3ba046.svg";